import { jsx } from 'react/jsx-runtime';
import Icon from '../../Icons/Icon.js';

var ExportIcon = Icon(jsx("path", { d: "M5,21c-1.1,0-2-.9-2-2V5c0-1.1,.9-2,2-2h14c1.1,0,2,.89,2,2h0v2.8l-2-1.8v-1H5v14h14v-1l2-1.8v2.8c0,1.1-.89,2-2,2H5Zm10.79-5.41l2.58-2.59H8.7v-2h9.67l-2.58-2.59,1.41-1.41,5,5-5,5-1.41-1.41Z" }), '0 0 24 24', 'ExportIcon');

export { ExportIcon as default };
